import { axiosInstance } from "./axiosInstance";

const createUserApi = (data) => axiosInstance.post("/users/add", data)

const loginApi = async (data) =>
  axiosInstance.post("/auth/login", data, { skipErrorToast: true });

const UserOperationClaimApi = (data) => axiosInstance.put("/UserOperationClaims/Update", data)

const getUserByIdApi = async (id, config = {}) =>
  axiosInstance.get(`/users/GetById/${id}`, config)

const updateUserApi = async (data) => axiosInstance.put("/users/update", data)

const getUserListApi = ({
  page,
  pageSize,
  roleId
}) => axiosInstance.post(`/users/getAll?roleId=${roleId}`, { page, pageSize })

const getDynamicUserSearchApi = (body, query) => {
  const params = new URLSearchParams({
    Page: String(query.page),
    PageSize: String(query.pageSize),
    roleId: String(query.roleId),
  });
  if (query.branchId) {
    params.set("branchId", String(query.branchId));
  }
  return axiosInstance.post(`/users/getAllByDynamic?${params.toString()}`, body);
};

const changePasswordApi = (data) => axiosInstance.put("/users/updatepassword", data)

const softDeleteUserForSuperAdminApi = (id) =>
  axiosInstance.delete(`/users/SoftDeleteForSuperAdmin/${id}`)

const restoreUserForSuperAdminApi = (id) =>
  axiosInstance.put(`/users/RestoreForSuperAdmin/${id}`)

export {
  loginApi,
  createUserApi,
  getUserByIdApi,
  updateUserApi,
  getUserListApi,
  UserOperationClaimApi,
  changePasswordApi,
  getDynamicUserSearchApi,
  softDeleteUserForSuperAdminApi,
  restoreUserForSuperAdminApi,
}
